// Generated by scripts/generate.py. Do not edit.
export const REQUIREMENT_CATALOG = {
    "target_kinds_by_kind": {
        "effector": [],
        "feed": [
            "feed"
        ],
        "input": [
            "device",
            "person"
        ],
        "interface": [
            "activity"
        ],
        "origin": [
            "directory"
        ]
    },
    "types": [
        {
            "alias_of": null,
            "capability": "effector.obs",
            "kind": "effector",
            "local": true,
            "name": "effector.obs.v1",
            "target_kinds": [
                "machine"
            ]
        },
        {
            "alias_of": null,
            "capability": "gaze",
            "kind": "input",
            "local": true,
            "name": "input.gaze.v1",
            "target_kinds": [
                "machine"
            ]
        },
        {
            "alias_of": null,
            "capability": "speaking",
            "kind": "input",
            "local": true,
            "name": "input.speaking.v1",
            "target_kinds": [
                "machine"
            ]
        },
        {
            "alias_of": null,
            "capability": null,
            "kind": "input",
            "local": false,
            "name": "input.key.v1",
            "target_kinds": [
                "device",
                "person"
            ]
        },
        {
            "alias_of": null,
            "capability": null,
            "kind": "input",
            "local": false,
            "name": "input.pointer.v1",
            "target_kinds": [
                "device",
                "person"
            ]
        },
        {
            "alias_of": null,
            "capability": null,
            "kind": "input",
            "local": false,
            "name": "input.axis.v1",
            "target_kinds": [
                "device",
                "person"
            ]
        },
        {
            "alias_of": null,
            "capability": null,
            "kind": "input",
            "local": false,
            "name": "input.text.v1",
            "target_kinds": [
                "device",
                "person"
            ]
        },
        {
            "alias_of": null,
            "capability": null,
            "kind": "input",
            "local": false,
            "name": "input.choice.v1",
            "target_kinds": [
                "device",
                "person"
            ]
        },
        {
            "alias_of": null,
            "capability": null,
            "kind": "input",
            "local": false,
            "name": "input.camera.v1",
            "target_kinds": [
                "device",
                "person"
            ]
        },
        {
            "alias_of": null,
            "capability": null,
            "kind": "input",
            "local": false,
            "name": "input.audio.v1",
            "target_kinds": [
                "device",
                "person"
            ]
        },
        {
            "alias_of": null,
            "capability": null,
            "kind": "feed",
            "local": false,
            "name": "feed.message.v1",
            "target_kinds": [
                "feed"
            ]
        },
        {
            "alias_of": null,
            "capability": null,
            "kind": "feed",
            "local": false,
            "name": "feed.amount.v1",
            "target_kinds": [
                "feed"
            ]
        },
        {
            "alias_of": null,
            "capability": null,
            "kind": "feed",
            "local": false,
            "name": "feed.record.v1",
            "target_kinds": [
                "feed"
            ]
        },
        {
            "alias_of": "feed.message.v1",
            "capability": "chat",
            "kind": "effector",
            "local": false,
            "name": "effector.chat.v1",
            "target_kinds": [
                "feed"
            ]
        },
        {
            "alias_of": "feed.amount.v1",
            "capability": "channel.points",
            "kind": "effector",
            "local": false,
            "name": "effector.channel_points.v1",
            "target_kinds": [
                "feed"
            ]
        },
        {
            "alias_of": "feed.record.v1",
            "capability": "clips",
            "kind": "effector",
            "local": false,
            "name": "effector.clips.v1",
            "target_kinds": [
                "feed"
            ]
        },
        {
            "alias_of": "feed.record.v1",
            "capability": "rooms",
            "kind": "effector",
            "local": false,
            "name": "effector.rooms.v1",
            "target_kinds": [
                "feed"
            ]
        },
        {
            "alias_of": null,
            "capability": null,
            "kind": "origin",
            "local": false,
            "name": "origin.directory.v1",
            "target_kinds": [
                "directory"
            ]
        }
    ]
};
